import { render, staticRenderFns } from "./WritingIsPrioNotification.vue?vue&type=template&id=22b8ed75&"
import script from "./WritingIsPrioNotification.vue?vue&type=script&lang=js&"
export * from "./WritingIsPrioNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports